// extracted by mini-css-extract-plugin
export default {"formCard":"SettingEmailTemplateForm_formCard__Zdht-","previewCard":"SettingEmailTemplateForm_previewCard__zFcmk","previewBody":"SettingEmailTemplateForm_previewBody__UZMKP"};